import { UpdatePackage } from "@/model/data/updates/UpdatePackage";
import { UpdatePackageAssociation } from "@/model/data/updates/UpdatePackageAssociation";
import { UpdatePackageAssociationEnum } from "@/model/data/updates/UpdatePackageAssociationEnum";
import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../../ServiceResponseData";

export class FetchAssociatedUpdatePackagesResData extends ServiceResponseData {
    associationPackages: UpdatePackageAssociation[];

    constructor(response: AxiosResponse) {
        super(response);
        this.associationPackages = [];
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    parse(data) {
        if (data.FullAssociatedPackages) {
            data.FullAssociatedPackages.forEach((v) => {
                var up = new UpdatePackageAssociation();
                up.parse(v);
                up.association = UpdatePackageAssociationEnum.all;
                this.associationPackages.push(up);
            });
        }

        if (data.NoAssociatedPackages) {
            data.NoAssociatedPackages.forEach((v) => {
                var up = new UpdatePackageAssociation();
                up.parse(v);
                up.association = UpdatePackageAssociationEnum.none;
                this.associationPackages.push(up);
            });
        }

        if (data.PartiallyAssociatedPackages) {
            data.PartiallyAssociatedPackages.forEach((v) => {
                var up = new UpdatePackageAssociation();
                up.parse(v);
                up.association = UpdatePackageAssociationEnum.partial;
                this.associationPackages.push(up);
            });
        }
    }
}
